module.exports = __webpack_public_path__ + "img/vaccine_record_bg.46d063b7.png";